<template>
  <div class="pc_device-info">
    <div class="info device-info">
      <div>
        <div>
          <img style="width: 210px; height: 210px" :src="data.productLogo" alt="" />
          <!-- <picture :srcset="productInfo.productLogo" type="image/avif"></picture> -->
        </div>
        <div class="device-name">{{ data.skuName }}</div>
        <div class="device-sku">{{ data.skuMessage }}</div>

        <template v-if="moneyData">
          <div class="total-price">
            <h5>{{ $t('PCModelList.index.totalPrice') }}</h5>

            <div class="money-div">
              <span class="dun">{{ moneyData.currencySymbol }}</span>
              {{ Number(moneyData.bonus) + (Number(moneyData.evaluation) || 0) + (Number(moneyData.expertDiscount) || 0)}}
            </div>
          </div>

          <div class="price-main">
            <div class="subsidy-div">
              <!--预估回收价-->
              <div class="subsidy-title">{{ $t('PCModelInfo.index.647h1f4yr6c0') }}</div>
              <div class="money-div money-div2">
                <span class="dun">{{ moneyData.currencySymbol }}</span
                >{{ moneyData.evaluation }}
              </div>
            </div>
            <div v-if="moneyData.bonus && moneyData.bonus > 0" class="subsidy-div">
              <!--预估补贴-->
              <div class="subsidy-title">{{ $t('PCModelInfo.index.647h1f4yso80') }}</div>
              <div class="money-div">
                <span class="dun">{{ moneyData.currencySymbol }}</span
                >{{ moneyData.bonus }}
              </div>
            </div>

            <div
              v-if="moneyData.expertDiscount && moneyData.expertDiscount > 0"
              class="subsidy-div"
            >
              <!--推广码补贴-->
              <div class="subsidy-title">{{ $t('component.tradeInProcess.expertDiscount') }}</div>
              <div class="money-div">
                <span class="dun">{{ moneyData.currencySymbol }}</span
                >{{ moneyData.expertDiscount }}
              </div>
            </div>
          </div>
        </template>

        <div class="select-div" @click="goChooseModel">
          {{ $t('PCDeviceInfo.index.646ymq6orm00') }}
        </div>

        <div v-if="activityInfo" class="activity-info">
          <div v-if="activityInfo.title" class="activity-title">{{ activityInfo.title }}</div>
          <div v-if="activityInfo.detail" class="activity-detail">{{ activityInfo.detail }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PCDeviceInfo',
  props: {
    data: Object,
    moneyData: Object,
    activityInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {};
  },
  methods: {
    goChooseModel() {
      this.$router.push({ name: 'Product' });
    }
  }
};
</script>

<style scoped lang="less">
.pc_device-info {
  width: 300px;
  font-size: 16px;
  color: #282828;
  margin-right: 24px;
  .info {
    background-color: #fff;
    border-radius: 8px;
  }
  .device-info {
    height: 775px;
    text-align: center;
    padding: 40px 16px 60px;
    box-sizing: border-box;
    .device-name {
      margin-top: 16px;
      font-weight: 600;
    }
    .device-sku {
      margin-bottom: 30px;
      font-weight: 600;
    }
    .select-div {
      color: #405FFF;
      cursor: pointer;
      width: 100%;
      background-color: #fff;
      height: 48px;
      border-radius: 4px;
      border: 1px solid #405FFF;
      line-height: 48px;
    }

    .money-div2 {
      color: #333;

      text-align: center;
      font-family: 'Helvetica Neue';
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
  .title {
    margin-top: 20px;
    height: 200px;
    padding: 40px 24px 73px;
    .tip {
      text-align: center;
      color: #282828;
      font-weight: 500;
      margin-bottom: 16px;
    }
    .tip-div {
      color: #6e6e6e;
    }
  }

  .price-main {
    display: flex;
    flex-direction: column;
    // height: 55px;
    margin-top: 0px;
    margin-bottom: 16px;
    padding: 12px 12px 0;
    background: #f8f8f8;
    border-radius: 8px;
    .money-div {
      font-weight: 600;

      // font-size: 40px;
      // line-height: 56px;
    }
    .subsidy-title {
      color: #6e6e6e;
      font-size: 14px;
      margin-bottom: 12px;
      // font-weight: 400;
      // line-height: 17px;
    }
    .subsidy-div {
      position: relative;
      color: #ff7b24;
      display: flex;
      justify-content: space-between;
    }
    // .subsidy-div:after {
    //   position: absolute;
    //   top: 29px;
    //   left: -31px;
    //   content: '+';
    //   width: 15px;
    //   height: 34px;
    //   line-height: 34px;
    //   text-align: center;
    //   font-size: 24px;
    //   color: #999;
    // }
    .dun {
      // font-size: 28px;
      font-size: 14px;
    }
  }

  .total-price {
    text-align: left;
    padding-left: 12px;
    h5 {
      margin: 0;
      color: #333;
      font-family: Helvetica;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-bottom: 4px;
    }
    .money-div {
      font-weight: 600;
      font-size: 36px;
      line-height: 44px;
      margin-bottom: 4px;
    }

    .dun {
      font-size: 18px;
    }
  }

  .activity-info {
    margin: 16px 0 0;
    padding: 12px;
    border-radius: 8px;
    background: #fff5eb;
    text-align: left;

    .activity-title {
      color: #ff7b24;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
    }

    .activity-detail {
      margin-top: 6px;
      color: #6e6e6e;
      font-size: 12px;
      line-height: 18px;
    }
  }
}
</style>
